import tasks from "../components/tasks.vue";

Vue.component("history", {
    props: ["user"],
    components: {
        tasks: tasks
    },
    data: function() {
        return {};
    }
});
